import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { MenuItem, ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { GridService } from 'src/app/_services/grid.service';

@Component({
  selector: 'app-rsa',
  templateUrl: './rsa.component.html',
  styleUrls: ['./rsa.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class RsaComponent implements OnInit {
  
  rsalist:any[]=[];
  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Update item'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/rsa-edit/update',data.data.id]);
      }   
    },
    { field: 'name',headerName: 'List Name' },  
    
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
        
     
          return '<a title="'+'Delete item'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
        _this.confirmationService.confirm({
          message: 'Attention: do you confirm the delete of the Residencies list?',
          accept: () => {
            _this.apiService.deleteRsa({id:params.data.id}).subscribe(data => {
              _this.addSingle('success', 'Success', 'Residencies list deleted');
              _this.gellhp();
            });
          }
        });
           
      }   
    },
  ];

  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

  constructor(
    private router: Router,
    private apiService: ApiService,
    private messageService: MessageService,
    public globalService: GlobalService,
    public gridService: GridService,

    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
   _this=this;
    this.gellhp();
  }
  gellhp(){
    this.apiService.get('surveys-rsa/listall',{}).subscribe(data => {
      this.rsalist=data.Result;
      });
  }

  
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    
  }



  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
    
}
var _this;
